import { template } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
import ProSanteConnect from 'core/services/pro-sante-connect';
import { service } from '@ember/service';
import AuthenticationOpenIdConnectLoader from 'core/components/authentication/open-id-connect-loader';
import Component from '@glimmer/component';
import WrModalContent from 'ember-wiser/components/wr/modal/content';
import type LoginProSanteConnectController from 'parog-web/controllers/login/pro-sante-connect';
interface Signature {
    Args: {
        controller: LoginProSanteConnectController;
    };
}
let LoginProSanteConnectRouteTemplate = class LoginProSanteConnectRouteTemplate extends Component<Signature['Args']> {
    @service
    proSanteConnect: ProSanteConnect;
    static{
        template(`
    <WrModalContent
      @targetModal='login-modal'
      @title='Connexion via Pro Santé Connect'
    >
      <AuthenticationOpenIdConnectLoader
        @authorizationCode={{@controller.code}}
        @openIdConnectService={{this.proSanteConnect}}
      />
    </WrModalContent>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
};
export default RouteTemplate(LoginProSanteConnectRouteTemplate);
